import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, OnDestroy, AfterViewInit } from '@angular/core';
import { ITaskV2 } from '@fi-app/task-v2/fi-task-v2';
import { FiAttachmentDisplaySize, ObjectTypes } from '@fi-shared/types';
import { ICommentModel, ICommentsContainer } from '@fi-shared/fi-comments/fi-comments';
import { Observable, Subject } from 'rxjs';
import { FiTaskV2HelperService } from '@fi-app/task-v2/fi-task-v2-helper.service';
import { Animations } from '@fi-shared/utils/animations';
import { FiCommentsListStateService } from '@fi-shared/fi-comments/fi-comments-list/services/fi-comments-list-state.service';

@Component({
    selector: 'fi-task-v2-comments',
    templateUrl: './task-v2-comments.component.html',
    styleUrls: ['./task-v2-comments.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-comments' },
    animations: [Animations.fadeHeight()],
    standalone: false,
})
export class FiTaskV2CommentsComponent implements AfterViewInit, OnDestroy {
    @Input({ required: true }) task: ITaskV2;
    @Input({ required: true }) comments: ICommentModel[];
    @Input() disableAddingComment: boolean = false;
    @Input() iconClass: string;
    @Input() isSimplifiedLayout: boolean = false;
    @Input() attachmentsDisplaySize: FiAttachmentDisplaySize = FiAttachmentDisplaySize.Medium;
    @Input() scrollToCommentId: number;
    
    protected readonly ObjectTypes = ObjectTypes;
    private ngOnDestroy$ = new Subject<void>();

    constructor(
        private fiTaskV2HelperService: FiTaskV2HelperService,
        private commentsListStateService: FiCommentsListStateService,
    ) {}

    public ngAfterViewInit(): void {
        this.commentsListStateService.emitCommentUpdateConnectionLine(ObjectTypes.Task, this.task.Id);
    }

    get hasEditAccess(): boolean {
        return this.fiTaskV2HelperService.hasEditAccess(this.task);
    }

    get commentsCount(): number {
        return this.commentsListStateService.getCommentsCount(ObjectTypes.Task, this.task.Id);
    }

    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
